import { IonSpinner } from '@ionic/react'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { logEvent } from '../../analytics/utils/firebaseUtils'
import Button from '../../components/actions/Button'
import StringInput from '../../components/inputs/StringInput'
import { trpc } from '../../modules/trpc'
import PublicWrapper from '../../wrappers/publicWrapper/PublicWrapper'

interface Props {}

const ForgottenPassword: React.FC<Props> = () => {
	const forgottenPasswordMutation = trpc.auth.resetPassword.useMutation()

	const [email, setEmail] = useState('')
	const [errorMessage, setErrorMessage] = useState('')
	const [successMessage, setSuccessMessage] = useState('')
	const [loading, setLoading] = useState(false)
	const { t } = useTranslation('pages_forgottenPassword')

	const onSubmit = async () => {
		try {
			logEvent('click-user-restore-password')

			setErrorMessage('')
			setSuccessMessage('')
			setLoading(true)

			await forgottenPasswordMutation.mutateAsync({ email })
			setLoading(false)

			setSuccessMessage(t('ohjeet'))
		} catch (error) {
			setLoading(false)
			setErrorMessage(t('eiKayttajaa'))
		}
	}

	return (
		<PublicWrapper id='forgotten-password'>
			<div className='flex flex-col gap-4'>
				<h1 className='text-text-dark dark:text-white text-xl text-center'>{t('otsikko')}</h1>
				<div className='info mt-4 text-center text-text-grey-200 dark:text-text-grey-100'>
					{t('info')}
				</div>
				{errorMessage && <div className='error-message'>{errorMessage}</div>}
				{successMessage && <div className='success-message'>{successMessage}</div>}
				{loading && <IonSpinner />}

				<StringInput
					label={t('sahkopostiosoite')}
					value={email}
					onChange={val => setEmail(val)}
					type='email'
					disabled={loading}
				/>

				<div className='flex flex-col gap-2'>
					<Button className='m-0' disabled={loading} onClick={onSubmit}>
						{t('laheta')}
					</Button>
					<Button className='hollow m-0 text-[#52ae32] dark:text-[#3cb49f]' routerLink='/login'>
						{t('takaisin')}
					</Button>
				</div>
			</div>
		</PublicWrapper>
	)
}

export default ForgottenPassword
